/**
 * Kopstorm: keep the PDP gallery in sync with a partially selected variant.
 *
 * The theme only jumps the gallery to a variant image when EVERY option is
 * selected (VariantPicker.getSelectedVariant needs a full match). On templates
 * where "Select first variant" is off, the size dropdown starts on
 * "Please select", so choosing a colour never resolves a variant and the
 * featured image stays on the previous colour.
 *
 * This script listens for the theme's own on:variant:change event, and when no
 * full variant is resolved it finds the first variant matching the options that
 * ARE selected and activates that variant's featured media.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.js-product';

  /**
   * Find the featured media id of the first variant matching the selected options.
   * @param {Array} variants - all variants for the product
   * @param {Array} selected - selected option values, null where not selected
   * @returns {?number} media id, or null
   */
  function findMediaId(variants, selected) {
    var fallback = null;
    var i;
    var j;
    var variant;
    var matches;

    if (!variants || !variants.length) return null;

    for (i = 0; i < variants.length; i += 1) {
      variant = variants[i];
      matches = true;

      for (j = 0; j < selected.length; j += 1) {
        if (selected[j] !== null && selected[j] !== undefined
          && variant.options[j] !== selected[j]) {
          matches = false;
          break;
        }
      }

      if (matches && variant.featured_media) {
        if (variant.available) return variant.featured_media.id;
        if (fallback === null) fallback = variant.featured_media.id;
      }
    }

    return fallback;
  }

  /**
   * Activate the media for the currently selected options.
   * @param {Element} section - product section element
   * @param {Array} variants - all variants for the product
   * @param {Array} selected - selected option values, null where not selected
   */
  function syncGallery(section, variants, selected) {
    var gallery = section.querySelector('media-gallery');
    var hasSelection = false;
    var mediaId;
    var mediaEl;
    var i;

    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    if (!selected || !selected.length) return;

    for (i = 0; i < selected.length; i += 1) {
      if (selected[i] !== null && selected[i] !== undefined) hasSelection = true;
    }
    if (!hasSelection) return;

    mediaId = findMediaId(variants, selected);
    if (!mediaId) return;

    mediaEl = gallery.querySelector('.main-image [data-media-id="' + mediaId + '"]');
    if (!mediaEl || mediaEl.hidden || mediaEl.classList.contains('is-active')) return;

    gallery.setActiveMedia(mediaId, true);
  }

  /**
   * Handle the theme variant change event.
   * @param {Event} evt - on:variant:change event
   */
  function onVariantChange(evt) {
    var section = evt.target.closest ? evt.target.closest(SECTION_SELECTOR) : null;

    // The theme already handles a fully resolved variant.
    if (!section || !evt.detail || evt.detail.variant) return;

    syncGallery(section, evt.detail.allVariants, evt.detail.selectedOptions);
  }

  /**
   * Run once on load, in case options were preselected from the URL.
   */
  function syncOnLoad() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      var picker = section.querySelector('variant-picker');

      if (!picker || typeof picker.getSelectedOptions !== 'function') return;
      if (picker.variant) return;
      if (!picker.data || !picker.data.variants) return;

      syncGallery(section, picker.data.variants, picker.getSelectedOptions());
    });
  }

  document.addEventListener('on:variant:change', onVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOnLoad);
  } else {
    syncOnLoad();
  }

  window.addEventListener('load', syncOnLoad);
}());
